import { FC, useCallback } from "react";
import { SearchProductsItemResponse, getProductById, searchProducts } from "../../services/ProductsService";

import { CSSProperties } from "@mui/styles";
import Selector from "components/Selector";
import localisation from "../../localisation";

export type SelectedProductDetails = {
    id: number;
    sku: string;
    description: string;
};

export type ProductSelectedCallback = (productDetails: SelectedProductDetails | null) => void;

type ProductSelectorProps = {
    onSelected: ProductSelectedCallback;
    initialProductId?: number;
    id?: string;
    style?: CSSProperties;
    smallSize?: boolean;
    helperText?: string;
    fieldCompanyId: number;
    numberOfSuggestions?: number;
    required?: boolean;
    isValid?: (isValid: boolean) => void;
};

const ProductSelector: FC<ProductSelectorProps> = (props) => {
    const { onSelected, fieldCompanyId, numberOfSuggestions, required, isValid } = props;

    return (
        <Selector<number, SearchProductsItemResponse>
            id={props.id}
            style={props.style}
            smallSize={props.smallSize}
            initialId={props.initialProductId}
            search={useCallback(
                (searchTerm) =>
                    searchProducts({
                        fieldCompanyId: fieldCompanyId,
                        sku: searchTerm,
                        description: null,
                        pageNumber: 1,
                        itemsPerPage: numberOfSuggestions || 5,
                    }).then((response) => response.items),
                [fieldCompanyId, numberOfSuggestions]
            )}
            getById={getProductById}
            render={useCallback((product) => `${product.sku} : ${product.description}`, [])}
            onSelected={useCallback(
                (productDetails) =>
                    onSelected(
                        !productDetails
                            ? null
                            : {
                                  id: productDetails.id,
                                  sku: productDetails.sku,
                                  description: productDetails.description,
                              }
                    ),
                [onSelected]
            )}
            localisation={{
                ...localisation.selector,
                helperText: props.helperText,
            }}
            required={required}
            isValid={isValid}
        />
    );
};

export default ProductSelector;
